//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions } from 'vuex';

export default {
  name: 'DetailsLogoCard',
  props: {
    item: { default: () => {}, type: Object },
    size: { default: 90, type: Number },
    noLine: { type: Boolean, default: false },
  },
  methods: {
    ...mapActions('jobs', ['setCurrentCompanyId']),
    gotoCompany(id) {
      if (id) {
        this.setCurrentCompanyId(id || 0);
        this.$router.push(`/Company/${id}`);
      }
    },
  },
};
